import React, { useState } from 'react';
import { Form, Button, Alert } from 'react-bootstrap';
import ActivityIndicator from './ActivityIndicator';

const LoginForm = ({ onSubmit, loading = false }) => {
  const [form, setForm] = useState({ username: '', password: '' });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(form);
  };

  return (
    <Form onSubmit={handleSubmit}>
      <Form.Group className="mb-3" controlId="username">
        <Form.Label>Username</Form.Label>
        <Form.Control
          name="username"
          type="text"
          value={form.username}
          onChange={handleChange}
          placeholder="Enter username"
          required
        />
      </Form.Group>

      <Form.Group className="mb-3" controlId="password">
        <Form.Label>Password</Form.Label>
        <Form.Control
          name="password"
          type="password"
          value={form.password}
          onChange={handleChange}
          placeholder="Enter password"
          required
        />
      </Form.Group>

      <Button variant="primary" type="submit" disabled={loading} className="w-100">
        {loading ? <ActivityIndicator /> : 'Login'}
      </Button>
    </Form>
  );
};

export default LoginForm;
